import React from "react";
import { Route, Redirect } from "react-router-dom";

const AdminRoute = ({ admin, component: Comp, ...rest }) => {
  return (
    <Route
      {...rest}
      component={(props) => {
        return admin ? (
          <Comp {...props} admin={admin} />
        ) : (
          <Redirect to="/admin" />
        );
      }}
    />
  );
};

export default AdminRoute;
